/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1053
 */

module.exports = {
  cloudSpaceManager: "style_cloudSpaceManager__2C_pk",
  cloudIconWarn: "style_cloudIconWarn__Bpisi",
  cloudIconError: "style_cloudIconError__1_IJn"
}
